import {RegressionsOutputNiveau} from './regression-output-niveau';

export interface ModellvariantenM1 {
  regressionOutput: RegressionOutput;
  koeffiziente: Koeffiziente;
  doublyRobustRegression: DoublyRobustRegression;
}

export interface Koeffiziente {
  standardAnalyseModell: StandardAnalyseModell;
  nurGrundlohn: StandardAnalyseModell;
  ohneZulagen: StandardAnalyseModell;
  ohneSonderzahlungen: StandardAnalyseModell;
  dummyVariablenfuerAusbildung: DummyVariablenfuerAusbildung;
  pqRegression: PqRegression;
}

interface PqRegression {
  Intercept: Intercept;
  Educ: Intercept;
  Tnr: Intercept;
  Exp: Intercept;
  Exp2: Intercept;
  Gender: Intercept;
}

interface DummyVariablenfuerAusbildung {
  Intercept: Intercept;
  Educ1: Intercept;
  Educ2: Intercept;
  Educ3: Intercept;
  Educ6: Intercept;
  Educ7: Intercept;
  Tnr: Intercept;
  Exp: Intercept;
  Exp2: Intercept;
  Skl1: Intercept;
  Skl2: Intercept;
  Skl3: Intercept;
  Pos3: Intercept;
  Pos4: Intercept;
  Gender: Intercept;
}

interface StandardAnalyseModell {
  Intercept: Intercept;
  Educ: Intercept;
  Tnr: Intercept;
  Exp: Intercept;
  Exp2: Intercept;
  Skl1: Intercept;
  Skl2: Intercept;
  Skl3: Intercept;
  Pos3: Intercept;
  Pos4: Intercept;
  Gender: Intercept;
}

export class Intercept {
  koeffizient?: number;
  signifikanz?: string;
  standardFehler?: number;
}

export interface RegressionOutput {
  standardAnalyseModell: RegressionsOutputNiveau;
  nurGrundlohn: RegressionsOutputNiveau;
  ohneZulagen: RegressionsOutputNiveau;
  ohneSonderzahlungen: RegressionsOutputNiveau;
  dummyVariablenfuerAusbildung: RegressionsOutputNiveau;
  pqRegression: RegressionsOutputNiveau;
}

export interface DoublyRobustRegression {
  geschlechtskoeffizient?: number;
  standardfehler?: number;
  zWert?: number;
  prZ?: number;
  sig0?: boolean;
  sig5?: boolean;
}

export class ModellVariablenKoefficienteM1 {
  Intercept: KoeffizienteRowData;
  Gender: KoeffizienteRowData;
  Educ: KoeffizienteRowData;
  Exp: KoeffizienteRowData;
  Exp2: KoeffizienteRowData;
  Tnr: KoeffizienteRowData;
  Skl1: KoeffizienteRowData;
  Skl2: KoeffizienteRowData;
  Skl3: KoeffizienteRowData;
  Skl4: KoeffizienteRowData;
  Skl5: KoeffizienteRowData;
  Skl6: KoeffizienteRowData;
  Skl7: KoeffizienteRowData;
  Skl8: KoeffizienteRowData;
  Pos1: KoeffizienteRowData;
  Pos2: KoeffizienteRowData;
  Pos3: KoeffizienteRowData;
  Pos4: KoeffizienteRowData;
  Pos5: KoeffizienteRowData;
  Educ1: KoeffizienteRowData;
  Educ2: KoeffizienteRowData;
  Educ3: KoeffizienteRowData;
  Educ4: KoeffizienteRowData;
  Educ5: KoeffizienteRowData;
  Educ6: KoeffizienteRowData;
  Educ7: KoeffizienteRowData;
  Educ8: KoeffizienteRowData;
  constructor() {
    this.Intercept = new KoeffizienteRowData();
    this.Gender = new KoeffizienteRowData();
    this.Educ = new KoeffizienteRowData();
    this.Exp = new KoeffizienteRowData();
    this.Exp2 = new KoeffizienteRowData();
    this.Tnr = new KoeffizienteRowData();
    this.Skl1 = new KoeffizienteRowData();
    this.Skl2 = new KoeffizienteRowData();
    this.Skl3 = new KoeffizienteRowData();
    this.Skl4 = new KoeffizienteRowData();
    this.Skl5 = new KoeffizienteRowData();
    this.Skl6 = new KoeffizienteRowData();
    this.Skl7 = new KoeffizienteRowData();
    this.Skl8 = new KoeffizienteRowData();
    this.Pos1 = new KoeffizienteRowData();
    this.Pos2 = new KoeffizienteRowData();
    this.Pos3 = new KoeffizienteRowData();
    this.Pos4 = new KoeffizienteRowData();
    this.Pos5 = new KoeffizienteRowData();
    this.Educ1 = new KoeffizienteRowData();
    this.Educ2 = new KoeffizienteRowData();
    this.Educ3 = new KoeffizienteRowData();
    this.Educ4 = new KoeffizienteRowData();
    this.Educ5 = new KoeffizienteRowData();
    this.Educ6 = new KoeffizienteRowData();
    this.Educ7 = new KoeffizienteRowData();
    this.Educ8 = new KoeffizienteRowData();
  }
}
export class KoeffizienteRowData {
  standardAnalyseModell: Intercept;
  nurGrundlohn: Intercept;
  ohneZulagen: Intercept;
  ohneSonderzahlungen: Intercept;
  dummyVariablenfuerAusbildung: Intercept;
  pqRegression: Intercept;
}
